export default {
  alerts(state) {
    return state.alerts;
  },
  selectedAlert(state) {
    return state.selectedAlert;
  },
  language(state) {
    return state.language;
  },

  // WebSocket getters
  isWebSocketConnected: (state) => state.websocketConnected,
  websocketStatus: (state) => {
    if (state.websocketConnected) {
      return "Connected";
    } else if (state.connectionStatus === "connecting") {
      return "Connecting...";
    } else if (state.connectionStatus === "error") {
      return "Connection Error";
    } else {
      return "Disconnected";
    }
  },
  connectionStatus: (state) => state.connectionStatus,
  lastKeepAliveTime: (state) => state.lastKeepAlive,
  layerVersionInfo: (state) => state.layerVersion,
  historyData: (state) => state.historyData,

  // New getters for API requirements
  shapefileContent: (state) => state.shapefileContent,
  shapefileVersion: (state) => state.shapefileVersion,
  shapefileVersionResponse: (state) => state.shapefileVersionResponse,
  historyRequest: (state) => state.historyRequest,
  historyResponse: (state) => state.historyResponse,
  uiTtlMinutes: (state) => state.uiTtlMinutes,
  // Auth
  isAuthenticated: (state) => state.isAuthenticated,
  isAdmin: (state) => {
    if (!state.authToken) return false;
    try {
      const parts = state.authToken.split('.');
      if (parts.length > 1) {
        const payload = JSON.parse(atob(parts[1]));
        return payload.role === 'admin';
      }
    } catch (e) {
      // ignore parse errors
    }
    return false;
  },
};
